module.exports = __webpack_public_path__ + "img/base_activites_jetski.582bc52e.svg";